import {WorkflowStep} from "../workflow-step";
import {WorkflowService} from "../workflow.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Component} from "@angular/core";

@Component({
  templateUrl: "./sync-cdf.template.pug",
})
export class SyncCdfComponent extends WorkflowStep {
  error: Error;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }

  handleError(event: Event) {
    this.error = event["error"] || undefined;
  }

  ready() {}
}
